export default function formatLargeNumber(num: number | string, precision = 1) {
    const map = [
        { suffix: 'T', threshold: 1e12 },
        { suffix: 'B', threshold: 1e9 },
        { suffix: 'M', threshold: 1e6 },
        { suffix: 'K', threshold: 1e3 },
        { suffix: '', threshold: 1 },
    ]

    const found = map.find((x) => Math.abs(+num) >= x.threshold)

    if (!found) return num

    const formatted =
        +num % found.threshold === 0 ? +num / found.threshold : (+num / found.threshold).toFixed(precision)
    return parseFloat(formatted.toString()) + found.suffix
}
